export const meetTypes = [5, 15, 30, 45, 60]
